function toggleDarkMode() {
  var body = document.body;
  var button = document.getElementById("toggle-button");
  if (body.classList.contains("dark-mode")) {
    body.classList.replace("dark-mode", "light-mode");
    window.localStorage.setItem("mode", "light");
    button.textContent = "Toggle dark mode";
  } else {
    body.classList.replace("light-mode", "dark-mode");
    window.localStorage.setItem("mode", "dark");
    button.textContent = "Toggle light mode";
  }
}

function loadTheme() {
  var mode = window.localStorage.getItem("mode");
  if (mode == "dark") {
    document.body.classList.replace("light-mode", "dark-mode");
  }
}

loadTheme();
